import { useEffect, useState } from 'react';

import { useSubmitProgress } from 'hooks/use-submit-progress';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, FileContentsPicker, InputGroup } from 'components/FormComponents';
import { SubmitProgressBar } from 'components/SubmitProgressBar/SubmitProgressBar';

const FileSubmittionModal = ({
  title,
  description,
  visible,
  onClose = () => {},
  onSubmit = () => {},
  isSubmitting = false,
  loadingLabel = 'We are intelligently creating your questionnaire...',
  completingLabel = 'Your questionnaire is almost ready to be shipped!',
}) => {
  const [fileData, setFileData] = useState();
  const { progress, status } = useSubmitProgress(isSubmitting, { resetWhen: visible });

  useEffect(() => {
    if (!visible) setFileData(undefined);
  }, [visible]);

  const handleSubmittion = async () => {
    await onSubmit(fileData);
  };

  return (
    <AnimatedModal title={title} visible={visible} onClose={onClose} noClose={isSubmitting}>
      <div>
        <InputGroup>
          <p className="t-small u-margin-bottom--large u-text-centered">{description}</p>
          {!isSubmitting && (
            <FileContentsPicker
              accept={{ 'application/pdf': ['.pdf'], 'application/msword': ['.doc', '.docx'] }}
              onChange={setFileData}
            />
          )}
        </InputGroup>
        <SubmitProgressBar
          progress={progress}
          status={status}
          loadingLabel={loadingLabel}
          completingLabel={completingLabel}
          className="mb-2"
        />
        <div className="d-flex u-width-100 justify-content-end">
          <Button
            type="secondary"
            onClick={onClose}
            disabled={isSubmitting}
            className="u-width-100 u-margin-top u-margin-right">
            Cancel
          </Button>
          <Button
            icon="search"
            className="u-width-100 u-margin-top"
            onClick={handleSubmittion}
            disabled={isSubmitting || !fileData}>
            {isSubmitting ? 'Processing...' : 'Process Document'}
          </Button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default FileSubmittionModal;
